import { MessageCircle, Radio, Phone, Settings } from "lucide-react"
import { useTranslation } from "@/clientWeb/i18n/LanguageContext"
import type { NavTab } from "./types"

interface NavItem {
  tab: NavTab
  labelKey: string
  Icon: React.ElementType
}

const NAV_ITEMS: NavItem[] = [
  { tab: "chats", labelKey: "presence.chats", Icon: MessageCircle },
  // { tab: "groups", labelKey: "presence.groups", Icon: Users },
  { tab: "broadcast", labelKey: "presence.broadcast", Icon: Radio },
  { tab: "calls", labelKey: "presence.calls", Icon: Phone },
  { tab: "settings", labelKey: "presence.settings", Icon: Settings },
]

interface ChatNavBarProps {
  selected: NavTab
  onChange: (tab: NavTab) => void
  variant?: "bottom" | "sidebar"
}

export function ChatNavBar({ selected, onChange, variant = "bottom" }: ChatNavBarProps) {
  const t = useTranslation()

  if (variant === "sidebar") {
    return (
      <aside className="flex flex-col items-center gap-1 px-2 py-4 bg-card border-r border-border w-16 shrink-0">
        {NAV_ITEMS.map(({ tab, labelKey, Icon }) => {
          const isActive = selected === tab
          const label = t(labelKey)
          return (
            <button
              key={tab}
              onClick={() => onChange(tab)}
              title={label}
              className={`flex flex-col items-center justify-center gap-1 w-11 h-11 rounded-xl transition-all
                ${isActive
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"}`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.8} />
              <span className={`text-[9px] font-medium leading-none ${isActive ? "text-primary" : ""}`}>
                {label}
              </span>
            </button>
          )
        })}
      </aside>
    )
  }

  return (
    <nav className="flex items-center bg-card border-t border-border shrink-0">
      {NAV_ITEMS.map(({ tab, labelKey, Icon }) => {
        const isActive = selected === tab
        const label = t(labelKey)
        return (
          <button
            key={tab}
            onClick={() => onChange(tab)}
            className="flex-1 flex flex-col items-center gap-1 py-2.5 relative transition-colors"
          >
            <span
              className={`flex items-center justify-center px-4 py-1.5 rounded-full transition-all
                ${isActive ? "bg-primary/10" : "bg-transparent"}`}
            >
              <Icon
                className={`w-5 h-5 transition-colors ${isActive ? "text-primary" : "text-muted-foreground"}`}
                strokeWidth={isActive ? 2.5 : 1.8}
              />
            </span>
            <span
              className={`text-[11px] font-medium leading-none transition-colors
                ${isActive ? "text-primary font-semibold" : "text-muted-foreground"}`}
            >
              {label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
